var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:search-line",
    clipPath: "url(#clip0_3441_33729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87495 1.5C6.85839 1.50009 5.85659 1.74327 4.95314 2.20927C4.04968 2.67527 3.27077 3.35056 2.68137 4.17882C2.09198 5.00707 1.7092 5.96426 1.56498 6.97053C1.42075 7.97681 1.51926 9.00298 1.85228 9.96344C2.1853 10.9239 2.74318 11.7908 3.47937 12.4918C4.21557 13.1928 5.10872 13.7076 6.08433 13.9932C7.05994 14.2788 8.0897 14.327 9.08771 14.1337C10.0857 13.9404 11.023 13.5112 11.8214 12.882L14.5604 15.621C14.7019 15.7576 14.8913 15.8332 15.088 15.8315C15.2846 15.8298 15.4728 15.7509 15.6118 15.6119C15.7509 15.4728 15.8297 15.2847 15.8315 15.0881C15.8332 14.8914 15.7576 14.702 15.6209 14.5605L12.8819 11.8215C13.6229 10.8815 14.0843 9.7518 14.2133 8.56179C14.3422 7.37179 14.1335 6.16952 13.6111 5.09257C13.0887 4.01562 12.2736 3.10752 11.2592 2.47217C10.2447 1.83683 9.07192 1.49992 7.87495 1.5ZM2.99995 7.875C2.99995 6.58207 3.51356 5.34209 4.4278 4.42785C5.34204 3.51361 6.58202 3 7.87495 3C9.16788 3 10.4079 3.51361 11.3221 4.42785C12.2363 5.34209 12.7499 6.58207 12.7499 7.875C12.7499 9.16793 12.2363 10.4079 11.3221 11.3221C10.4079 12.2364 9.16788 12.75 7.87495 12.75C6.58202 12.75 5.34204 12.2364 4.4278 11.3221C3.51356 10.4079 2.99995 9.16793 2.99995 7.875Z",
    fill: "#004877"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3441_33729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.4176c81fa932b902d2bc24bc2b7371ef.svg";
export { ForwardRef as ReactComponent };